import { NgModule } from '@angular/core';
import './df-catalog.config';
import { RouteResource } from './route/route.resource';

@NgModule({})
export class DfCatalogModule {
    constructor(routeResource: RouteResource) {
        routeResource.appInitialize();
    }
}
